import React from "react";
import AppRouter from "./routes/Router";

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
